<template>
  <div class="overlay" :class="!isAgreed ? 'agreement-required' : ''">
    <div class="return" @click="goToPreviousPage()" v-if="isAgreed">
      <img src="@/assets/LeftWhite.svg" alt="left-caret icon" /> <span>{{ $t('legal.generalCondition.return') }}</span>
    </div>
    <div class="agreement-container">
      <language-selection class="language-selection"
                          @languageChange="changeLanguage"
                          :languages="languages"
                          :language="language"
      />
      <div @scroll="onScroll" class="general-condition-blocs">
        <general-condition-fr v-if="language === 'fr'" />
        <general-condition-en v-else />
      </div>
      <div v-if="!isAgreed" class="general-condition-validation">
        <general-condition-validate-fr :can-agree="canAgree" v-if="language === 'fr'" @onAgree="onAgree" />
        <general-condition-validate-en :can-agree="canAgree" v-else @onAgree="onAgree" />
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSelection from './LanguageSelection'
import GeneralConditionEn from './GeneralConditionEn'
import GeneralConditionValidateEn from './GeneralConditionValidateEn'
import GeneralConditionFr from './GeneralConditionFr'
import GeneralConditionValidateFr from './GeneralConditionValidateFr'

export default {
  name: 'GeneralCondition',
  components: {
    LanguageSelection,
    GeneralConditionEn,
    GeneralConditionValidateEn,
    GeneralConditionFr,
    GeneralConditionValidateFr
  },
  data() {
    return {
      languages: ['en', 'fr'],
      language: this.$i18n.locale,
      canAgree: false
    }
  },
  created() {
    if (!this.isAgreed) {
      // document.body.classList.add('no-scroll')
    }
  },
  watch: {
    isAgreed: function (newVal) {
      /* if (!newVal) {
        document.body.classList.add('no-scroll')
      } else if (document.body.classList.contains('no-scroll')) {
        document.body.classList.remove('no-scroll')
      } */
    }
  },
  destroyed() {
    /* if (document.body.classList.contains('no-scroll')) {
      document.body.classList.remove('no-scroll')
    } */
  },
  methods: {
    changeLanguage(language) {
      this.language = language
    },
    goToPreviousPage() {
      this.$router.go(-1)
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      // removing 200px so we can handle bad rounding and unexpected margin..
      if (scrollTop + clientHeight >= scrollHeight - 200) {
        this.canAgree = true
      }
    },
    async onAgree() {
      await this.$store.dispatch('setUserAgreement')
      // handle redirect to previous page if agreement were needed before
      if (this.$route.query.redirectToPath) {
        this.$router.replace(this.$route.query.redirectToPath)
      } else {
        this.$router.replace({ name: 'homePage' })
      }
    }
  },
  computed: {
    isAgreed() {
      return this.$store.getters.user.agreement
    }
  }
}
</script>
<style scoped lang="scss" src="./Return.scss"></style>
<style scoped lang="scss">
@media only print {

  /* Fix for printing in Firefox */
  .agreement-required {
    position: static !important;
    overflow: visible !important;
  }

  .content {
    display: block !important;
  }

  ::v-deep .locale-content {
    .bloc {
      display: block !important;
      box-shadow: none !important;
    }

    .validation {
      display: none !important;
    }
  }
  /* End of Fix for printing in Firefox */
}

.overlay {
  opacity: 1;
  background-color: #F2F2F2;
  width: 100%;
  z-index: 1;

  @media (max-width: $medium) {
    margin: -25px;
  }

  &.agreement-required {
    position: fixed;
    top: 0;
    overflow: auto;
    z-index: 3;

    .agreement-container {
      display: flex;
      height: 100vh;
      padding: 5px;
      flex-direction: column;

      .language-selection, .general-condition-validation {
        flex: none;
      }

      .general-condition-blocs {
        flex-grow: 1;
        overflow-y: scroll;
      }
    }
  }
}

.agreement-container {
  max-width: 900px;
  margin: 0 auto 60px auto;
  color: $black-color;
}

/* Apply CSS to child components */
::v-deep .locale-content {
  width: 100%;
  text-align: justify;

  .bolder {
    font-weight: bolder;
  }

  .bloc {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 10px 20px;
    flex-direction: column;
    box-sizing: border-box;
    background: white;
    box-shadow: 2px 7px 8px 0 rgba(69, 69, 69, 0.20);

    .logo-container {
      text-align: center;

      .cannect-logo {
        padding: 50px 0;
      }
    }
  }

  .bloc + .bloc, .validation {
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 405px) {
      zoom: 65%;
    }
  }

  .validation {
    padding-top: 50px;

    .button {
      align-self: center;
      width: 295px;

      span {
        text-transform: uppercase;
      }
    }
  }

  h1 {
    color: $primary-color;
    font-size: 24px;
    text-align: center;
    margin: 0 auto;
  }

  h2 {
    font-size: 16px;
  }

  h3 {
    color: $primary-color;
    font-size: 16px;
    margin: 14px 0;
  }

  h4 {
    margin: 10px 0 0;
    font-size: 16px;
  }

  .title {
    margin: 0 auto 50px;
  }

  .welcome-text {
    margin-bottom: 20px;

    p {
      margin: 11px 0;
    }
  }

  .subsection {
    p:first-of-type {
      margin-top: 0;
    }
  }

  p {
    font-size: 16px;
    margin: 8px 0;
  }

  a.link {
    color: $primary-color;
    cursor: pointer;
  }

  table {
    border-collapse: collapse;

    td {
      border: 2px solid #cccccc;
      padding: 10px;
      vertical-align: baseline;
    }
  }

  .annexe {
    table {
      text-align: left;
      font-size: 12px;

      td {
        vertical-align: middle;
      }
    }
  }
}
</style>
